
export function validateSwedishSsn(idNumber: string) {
    var personnummer = require('personnummer.js');    

    return (idNumber.length === 12 && personnummer.validate(idNumber));
}